<template>
  <div class="container">
 
<titles v-if="replayDetails.details" :staticTitle="replayDetails.details.title" /> 
<!-- <instruction v-if="quizDetails.type" :qtype="quizDetails.type" /> -->
<generating v-if="isGenerating" :message="'Grading Question...'" :color="'info'" />
<quiz-question v-if="isQuestion" :question="replayQuestion.question" />
<question-choices v-if="isQuestion" @submitted="checkReplay" :questid="replayQuestion.id" :choices="replayQuestion.choices" />
<quiz-not-found v-if="isNoReplay" />
<finished-replay v-if="isFinished" :results="fetchedResults" @continueQuiz="goLive" />

  </div>
</template>

<script>
import db from '../../../lib/db'
import Titles from '../../components/common/Title'
import Instruction from '../../components/common/Instruction'
import QuizQuestion from '@/components/common/QuizQuestion'
import QuizNotFound from '@/components/common/QuizNotFound'
import FinishedReplay from './FinishedReplay'
import Generating from '@/components/common/GeneratingLoad'
import QuestionChoices from '@/components/common/QuizChoices'

export default {
  name: 'Home',
  props: {
    msg: String
  },
  data () {
    return{
      replayDetails: {},
      replayQuestion: {},
      getResults: {},
      isQuestion: false,
      isNoReplay: false,
      isFinished: false,
      isGenerating: false,
      replayData: {
        quizid: '',
        showid: '',
        id: '',
      },
      quizDetails: {
        question: '',
        choices: {}, 
        type: ''
      },
      repReady: false
    }
  },
  methods: {
    clearViews: function() {
      this.isNoReplay = false
      this.isGenerating = false,
      this.isQuestion = false
      this.isFinished = false
      this.getResults = {}
      this.replayDetails = {}
      this.replayQuestion = {}
    },
    goLive: function(quiz) {
      this.clearViews()
      this.$router.push({ name: 'quiz', params: { quizid: quiz }, query: {replay: true} })
    },
    getReplay: function (path) {
      return db.getRef().ref('replay/'+this.$route.params.replayid).once('value').then((snapshot) => {
        this.replayData = snapshot.val()
        return snapshot.val()
      // }).then((data) => {
      //   console.log('read y')
      //   this.repReady = true
      })
    },
    getQuiz: function (quiz) {
      return db.getRef().ref('quizquestions/'+quiz.quizid+'/questions/'+quiz.questionid)
      .once('value').then((snapshot) => {
      console.log('show quiz data ', snapshot.val())
      this.quizDetails = snapshot.val()
      return snapshot.val()
      })
    },
    getQuestion: function (quiz){
      return db.getRef().ref('quizquestions/'+quiz.quiz).once('value').then((snapshot) => {
        if(snapshot.child('questions/'+quiz.question).exists()) {
        console.log('the questoin l,', quiz.question)
        this.replayDetails = snapshot.val()
        this.replayQuestion = snapshot.child('questions/'+quiz.question).val()
        this.isQuestion = true
        // console.log(this.replayQuestion.choices)
        }
        else{
          this.showNoReplay()
          console.log('no replay found here at ',this.$route.params)
        }
      })
      .catch((error) => {
        console.log('eror getting question ', error)
      })
    },
    showNoReplay: function() {
      this.clearViews()
      this.isNoReplay = true
    },
    showResult: function() {
      this.clearViews()
      this.isFinished = true
      return true
    },
    userLogin: function () {
       return db.anonAuth().then((user) => {
          console.log('anon credentia ', user.user.uid)
          return user.user
        })
        },
      checkReplay: function(question,answer){
        const payload = {question: question, answer:answer, quiz: this.$route.params.quiz}
        this.isQuestion = false
        this.isGenerating = true
          return db.callFunc('checkReplay')(payload).then((result) => {
            this.showResult();
            return result.data
            }).then((res) => {
          console.log('results are in ', res)
            this.getResults = res

        })
        .catch((error) => {
          console.log('cheking error ', error)
          return error
        })
    },
      initReplay: function () {
        this.clearViews()
        return this.userLogin().then((user) => {
           this.getQuestion(this.$route.params).then((ret) => {
            console.log('replay initiated ', ret)
          })

      })
      }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      this.initReplay()
      console.log('route chage quer')

    }
   },
   computed: {
      fetchedResults: function() {
          return this.getResults
          }

      },

  created () {
    this.initReplay()
    // this.getQuestion(this.$route.params)
    // this.getReplay()
    // .then((quizData) => {
    //   console.log('aaaa ', quizData)
    //   this.getQuiz(quizData)
    // }).then(()=>{
    //   this.repReady = true
    // })
  },
  components: {
    Titles,
    Instruction,
    QuizQuestion,
    QuizNotFound,
    QuestionChoices,
    Generating,
    FinishedReplay
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
